module.exports = __webpack_public_path__ + "static/img/NU.69081831.svg";